import RepackingDetail from '@/models/Repacking/RepackingDetail';

export default class RepackingDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.repackingId  = '';
		this.repackingRepackingNo = '';
		this.deliveryInstructionDetailId  = '';
		this.deliveryInstructionDetailPart = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.repackStatusId  = '';
		this.repackStatusName = '';
		this.repackById  = '';
		this.repackByFirstName = '';
		this.startDateFrom = '';
		this.startDateTo = '';
		this.finishDateFrom = '';
		this.finishDateTo = '';
		this.qtyRepack = '';
		this.qtyOutstanding = '';
		this.qtyFullfiled = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			repackingId : '0',
			repackingRepackingNo : '0',
			deliveryInstructionDetailId : '0',
			deliveryInstructionDetailPart : '0',
			partId : '0',
			partPartNumber : '0',
			repackStatusId : '0',
			repackStatusName : '0',
			repackById : '0',
			repackByFirstName : '0',
			startDateFrom : '0',
			startDateTo : '0',
			finishDateFrom : '0',
			finishDateTo : '0',
			qtyRepack : '0',
			qtyOutstanding : '0',
			qtyFullfiled : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}